// API configuration for the application
// This will use relative paths in production which work with Vercel

// For development environments, use the full URL with port
// For production (Vercel), use relative paths
const isDevelopment = process.env.NODE_ENV === "development";

export const API_URL = isDevelopment ? "http://localhost:3001" : "";

// Frontend base URL - used for payment redirects
export const FRONTEND_BASE_URL = isDevelopment
  ? "http://localhost:3000"
  : window.location.origin;

// Zorrocore (Azure) base URL - used for all zorrocore API calls
export const ZORROCORE_BASE_URL = process.env.REACT_APP_ZORROCORE_API_URL;

// API endpoints
export const ENDPOINTS = {
  GENERATE_IMAGE: `${API_URL}/api/generate-image`,
  EDIT_IMAGE: `${API_URL}/api/edit-image`,
  GENERATE_VARIATIONS: `${API_URL}/api/generate-variations`,
  GENERATE_VARIATIONS_ASYNC: `${API_URL}/api/generate-variations-async`,
  UPLOAD_IMAGE: `${API_URL}/api/upload-image`,
  PREDICTION: `${API_URL}/api/prediction`,
  DOWNLOAD_IMAGE: `${API_URL}/api/download-image`,
  OPENAI_PROXY: `${API_URL}/api/openai-proxy`,
  EXTRACT_COLORS: `${API_URL}/api/extract-colors`,

  // Master Catalog endpoints
  CATALOG_GENERATE_DATA: `${API_URL}/api/catalog/generate-data`,
  CATALOG_PROCESS_BATCH: `${API_URL}/api/catalog/process-batch`,
  CATALOG_COMPLETE: `${API_URL}/api/catalog/complete-catalog`,
  CATALOG_PRODUCTS: `${API_URL}/api/catalog/products`,
  CATALOG_BULK_UPDATE: `${API_URL}/api/catalog/bulk-update`,
  CATALOG_EXPORT: `${API_URL}/api/catalog/export`,

  // Project management endpoints
  PROJECTS_LIST: `${API_URL}/api/projects`,
  PROJECTS_GET: `${API_URL}/api/projects`, // [id] will be appended in the request
  PROJECTS_CREATE: `${API_URL}/api/projects/create`,
  PROJECTS_UPDATE: `${API_URL}/api/projects`, // [id] will be appended in the request - Legacy endpoint
  PROJECTS_UPDATE_POST: `${API_URL}/api/projects/update`, // New POST-based update endpoint
  PROJECTS_PATCH_FEATURE: `${API_URL}/api/projects/patch-feature`, // Atomic field-level patch (tech pack autosave fast path)
  PROJECTS_DELETE: `${API_URL}/api/projects`, // [id] will be appended in the request

  // Project management endpoints
  ZORRO_PROJECTS_LIST: `${ZORROCORE_BASE_URL}/api/projects/generic`, // POST call
  ZORRO_PROJECTS_GET: `${ZORROCORE_BASE_URL}/api/projects/generic`, // GET call, [id] will be appended in the request
  ZORRO_PROJECTS_CREATE: `${ZORROCORE_BASE_URL}/api/projects/generic/create`,
  ZORRO_PROJECTS_UPDATE: `${ZORROCORE_BASE_URL}/api/projects/generic/update`, // [id] will be appended in the request
  ZORRO_PROJECTS_DELETE: `${ZORROCORE_BASE_URL}/api/projects/generic/delete`, // [id] will be appended in the request

  // Photoshoot endpoints
  PHOTOSHOOT_ASYNC: `${API_URL}/api/photoshoot-async`,
  ZORROCORE_PROJECT_STATUS: `${API_URL}/api/azure/project-status`,

  // Watermark endpoint
  APPLY_WATERMARK: `${API_URL}/api/apply-watermark`,

  // Color Changer endpoints
  COLOR_CHANGER_GENERATE: `${API_URL}/api/color-changer/generate`,
  COLOR_CHANGER_ANALYZE_ZONES: `${API_URL}/api/color-changer/analyze-zones`,
  COLOR_CHANGER_START: `${API_URL}/api/color-changer/fal-start-job`,
  COLOR_CHANGER_STATUS: `${API_URL}/api/color-changer/fal-status`,

  // Garment Editor endpoints
  GARMENT_EDITOR_START: `${API_URL}/api/garment-editor/start-job`,
  GARMENT_EDITOR_STATUS: `${API_URL}/api/garment-editor-status`,

  // Product View Generator endpoints (legacy)
  PRODUCT_VIEW_GENERATOR_START: `${API_URL}/api/product-view-generator/start-job`,
  PRODUCT_VIEW_GENERATOR_STATUS: `${API_URL}/api/product-view-generator-status`,

  // Lookbook Creator endpoints (Nano Banana 2)
  LOOKBOOK_CLASSIFY: `${API_URL}/api/lookbook/classify`,
  LOOKBOOK_START: `${API_URL}/api/lookbook/start-job`,
  LOOKBOOK_STATUS: `${API_URL}/api/lookbook/status`,
  
  // Nano-Banana endpoints (for new flatlay workflow)
  NANO_BANANA_START: `${API_URL}/api/nano-banana/start-job`,
  NANO_BANANA_STATUS: `${API_URL}/api/nano-banana/status`,
  
  // Garment categorization
  CATEGORIZE_GARMENT: `${API_URL}/api/categorize-garment`,

  // Instagram Photoshoot endpoints
  INSTAGRAM_PHOTOSHOOT_START: `${API_URL}/api/instagram-photoshoot/start-job`,

  // Re-Fabric (Fabric Swapper) endpoints
  REFABRIC_ANALYZE: `${API_URL}/api/refabric/analyze-garment`,
  REFABRIC_START: `${API_URL}/api/refabric/start-job`,
  REFABRIC_STATUS: `${API_URL}/api/refabric/status`,

  // Free-tools endpoints (public, no-auth). Image accelerator for the pricing
  // calculator — optional; the tool is fully usable without it.
  TOOLS_PRICING_ANALYZE: `${API_URL}/api/tools/pricing-analyze`,
  TOOLS_CARE_DECODE: `${API_URL}/api/tools/care-label-decode`,

  // Zorrocore integration endpoints
  ZORROCORE_BASE_URL: ZORROCORE_BASE_URL,
  ZORROCORE_USER_CREATE: `${ZORROCORE_BASE_URL}/api/user/create`,
  ZORROCORE_FILE_UPLOAD: `${ZORROCORE_BASE_URL}/api/file/upload`,
  ZORROCORE_GET_FILE: `${ZORROCORE_BASE_URL}/api/file`,
};
